'use client'

import React from 'react'
import { Button, ButtonProps } from './button'

interface TrackedNavButtonProps extends ButtonProps {
  // Add any specific props needed beyond standard ButtonProps if necessary
}

export const TrackedNavButton = React.forwardRef<HTMLButtonElement, TrackedNavButtonProps>(
  ({ onClick, ...props }, ref) => {
    return <Button onClick={onClick} ref={ref} {...props} />
  }
)

TrackedNavButton.displayName = "TrackedNavButton" 